<template lang="pug">
  div
    .text-neutral-700
      .yz-heading-9 {{ $t('panel.staff_identification_list') }}
      .yz-regular-body-xs {{ $t('panel.staff_identification_description') }}

      .mt-6
        yz-data-table(:headers="staffIdHeaders" :items="selectedItems" body-height="50px")
          template(#item.panel="{ item }")
            panel-dropdown(v-if="item.editable" v-model="item.panel" :required="item.staffId !== '' && item.staffId !== null" :required-error-message="$t('panel.panel_required')")
            .yz-regular-body-sm(v-else) {{ (item.panel && item.panel.name) || '-' }}
          template(#item.staffId="{ item }")
            yz-text-field(v-if="item.editable" v-model="item.staffId" :required="item.panel !== '' && item.panel !== null" :required-error-message="$t('panel.staff_id_required')" :placeholder="$t('panel.enter_staff_id')" clearable)
            .yz-regular-body-sm(v-else) {{ item.staffId || '-' }}
          template(#item.actions="{ item, index }")
            div(style="text-align: end;")
              yz-btn.mr-2(icon="$yzi-trash-03" size="sm" icon-size="16px" outlined icon-color="yz-danger-500" @click="deleteStaffId(item, index)")
              yz-btn(icon="$yzi-edit-02" size="sm" icon-size="16px" outlined icon-color="yz-neutral-500" :disabled="item.editable" @click="editStaffId(item)")

        yz-btn.mt-3(:label="$t('panel.add_more')" outlined, prepend-icon="$yzi-plus" icon-size="14" size="md" background-color="white" @click="addMoreStaffId")
</template>

<script>
import PanelDropdown from '@/components/clinic/panel/PanelDropdown.vue'

export default {
  components: { PanelDropdown },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      staffIdHeaders: [
        { text: this.$t('panel.panel'), value: 'panel', align: 'start', width: '50%' },
        { text: this.$t('panel.staff_id_field'), value: 'staffId', align: 'start' },
        { text: '', value: 'actions', align: 'end', width: '80px', cellClass: 'pl-0' }
      ]
    }
  },
  computed: {
    selectedItems: {
      get() {
        const items = this.items
        // Make first item editable only if it's empty (no data)
        if (items.length > 0 && items[0].editable === undefined) {
          const firstItem = items[0]
          const isEmpty = !firstItem.panel && !firstItem.staffId
          this.$set(firstItem, 'editable', isEmpty)
        }
        return items
      },
      set(newValue) {
        this.$emit('update:items', newValue)
      }
    }
  },
  methods: {
    editStaffId(item) {
      this.$set(item, 'editable', true)
    },
    deleteStaffId(item, index) {
      if (this.selectedItems.length > 1) {
        this.selectedItems.splice(index, 1)
      } else {
        // Reset the single item if it's the last one and make it editable since it's now empty
        this.$set(this.selectedItems, 0, { panel: '', staffId: '', editable: true })
      }
    },
    addMoreStaffId() {
      this.selectedItems.push({ panel: '', staffId: '', editable: true })
    }
  }
}
</script>

<style scoped></style>
